import { Component } from '../../../concepts/objects';

export type LensAspectKind = 'property' | 'assocation' | 'value';

export interface LensAspect {

    readonly id: string;
    readonly type: string;
    readonly name: string;
    readonly description: string;
    readonly kind: LensAspectKind;

    read(elmt: Component): unknown;
}

export const LensAspect = {
    create(type: string,
        id: string,
        name: string,
        description: string,
        kind: LensAspectKind,
        read: (elmt: Component) => unknown): LensAspect {
        return { type, id, name, description, kind, read };
    }
};
